<template>
    <div id="about" class="bottom-corner-background-img main-component-container">
        <v-card-title class="component-title">
            <img alt="AboutTitle" v-bind:src="require('@/assets/About.png')" class="component-title-image">
        </v-card-title>
        <div class="component-content">
          <div class="row">
            <div class="component-locale-text">
                  <p v-for="(text, index) in $i18n.messages[$i18n.locale].about.content" :key="index">{{ text }}</p>
            </div>
            <div class = "row flex-item-space-between">
            <div ><img alt="Ilustration" v-bind:src="require('@/assets/Vero.png')" class=" content-image"></div>
          <!--  <div>
              <img alt="Ilustration" v-bind:src="require('@/assets/Vero.png')" class="image content-image">
            </div>-->
            </div>
          </div>
        </div>

    </div>
</template>

<script>

export default {
    name:'About'
}
</script>

<style scoped>

.row{
  padding-bottom: 1rem;
}
.bottom-corner-background-img{
  background-image: url('~@/assets/LogoBack.png');
}
.flex-item-space-between{

  justify-content: space-between;
}

@media only screen and (max-width: 750px) {
  .bottom-corner-background-img{

    -background-size: 20rem,auto;
  }
  .component-locale-text{
    padding-left: 0%;
    padding-right: 0%;
  }

}
/*@media (max-width: 572px) {
  .bottom-corner-background-img{
    background-position: right -30px bottom ;
    background-size: 16.5rem,auto;


  }
  .content-image{
      width: 15rem;
  }
  .about{

    padding-bottom: 0;
  }
}*/
@media (max-width: 480px) {
  .bottom-corner-background-img{
    -background-size: 12rem,auto;
  }
  .content-image{
      width: 10rem;
  }
}
</style>
